// extracted by mini-css-extract-plugin
export default {"submitButton":"submitButton__MheOrWMaz82JehRcWvyG","hasLoader":"hasLoader__wckltEk3TkjoMbrUBd3U"};